import { Note, type Transcription } from 'src/@types/notes-transcription';
import { addListener } from '../common';

type SocketChannel = {
  metadata: {
    noteStartedBy: string;
  };
  name: string;
  voiceChannelRoom: string;
  participants: any;
  _id: string;
};

type SocketTakingNotes = {
  channel: SocketChannel;
  document: Note;
};

type SocketTranscriptionLoaded = {
  document: Note;
};
export const startTakingNotes = addListener<SocketTakingNotes>(
  '/voice-channel/take-notes-started',
);

export const stopTakingNotes = addListener<SocketTakingNotes>(
  '/voice-channel/take-notes-ended',
);

export const transcriptionLoaded = addListener<SocketTranscriptionLoaded>(
  '/voice-channel/notes-available',
);

export const transcriptionSpeaker = addListener<Transcription>(
  '/voice-channel/notes-speaker-changed',
);
